import { render, staticRenderFns } from "./DistributionWindow.vue?vue&type=template&id=1c312338&"
import script from "./DistributionWindow.vue?vue&type=script&lang=js&"
export * from "./DistributionWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c312338')) {
      api.createRecord('1c312338', component.options)
    } else {
      api.reload('1c312338', component.options)
    }
    module.hot.accept("./DistributionWindow.vue?vue&type=template&id=1c312338&", function () {
      api.rerender('1c312338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/MblManagement/components/DistributionWindow.vue"
export default component.exports